import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {Field, formValueSelector} from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import {Dialog, RaisedButton, IconButton} from "material-ui";
import CreateIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ControlPointIcon from 'material-ui/svg-icons/image/control-point';

import { changePort } from 'actions/regions/ports';
import { formName } from 'data/formNames';
import {length, numericality, required} from "redux-form-validators";

const styles = {
    icon: { iconStyle: { color: '#00bcd4' }},
    textField: {
        floatingLabelStyle: {
            fontSize: '14px'
        }
    }
};

class Details extends React.Component {
    constructor(props) {
        super(props);

        this.addCapacity = this.addCapacity.bind(this);
        this.removeCapacity = this.removeCapacity.bind(this);
    }

    addCapacity() {
        const { fields } = this.props;

        fields.push({
            name: '',
            value: '',
        });
    }

    removeCapacity(index) {
        const { fields } = this.props;

        fields.remove(index);
    }

    render() {
        const { fields, min, max } = this.props;

        return (
            <Fragment>
                {
                    fields.map((field, index) => {
                        return <Fragment key={index}>
                            <div className='item middle-xs'>
                                <Field
                                    component={TextField}
                                    name={`${field}.name`}
                                    floatingLabelText={'Name'}
                                    fullWidth
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[required(), length({ min: 3, max: 266 })]}
                                />

                                <Field
                                    component={TextField}
                                    name={`${field}.value`}
                                    floatingLabelText={'Value'}
                                    fullWidth
                                    floatingLabelStyle={styles.textField.floatingLabelStyle}
                                    validate={[required(), numericality({ '<=': max, '>=': min, int: true })]}
                                />

                                <div className='edit'>
                                    <div className='icon delete-icon'>
                                        <IconButton
                                            iconStyle={styles.icon.iconStyle}
                                            onClick={() => {
                                                this.removeCapacity(index);
                                            }}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    })
                }

                <div className='row add-capacity'>
                    <div className='col-xs-9'></div>
                    <div className='col-xs-3 middle-xs end-xs'>
                        <div className='text'>Add capacity</div>

                        <IconButton
                            iconStyle={styles.icon.iconStyle}
                            onClick={this.addCapacity}>
                            <ControlPointIcon />
                        </IconButton>
                    </div>
                </div>
            </Fragment>
        )
    }
}

Details.propTypes = {

};

Details.defaultProps = {

};

const selector = formValueSelector(formName.portCreate);
export default connect(
    (state, ownProps) => {
        return {
            ...ownProps,
            liftsCranes: selector(state, 'liftsCranes'),
            port: state.port,
        };
    },
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(Details);



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/LiftAndCranes/Details.jsx